import React, { Component } from 'react';
import { browserHistory, withRouter } from 'react-router';

import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import {
  StyledHeader,
  StyledMain,
  StyledHeaderContainer,
  StyledAddButton,
  StyledTableContainer,
} from 'helpers/StyledTableComponentsHelper';
import camelCase from 'lodash/camelCase';

import {
  getAllPurchaseOrders,
  getPurchaseOrderStats,
  getPurchaseOrder,
  getVendors,
  getGlAccounts,
  getExpenseTypes,
} from 'actions/landlordPurchaseOrdersActions';

import { getProperties, getUnits } from 'actions/landlordPropertiesActions';

import { AccentColor } from 'helpers/AccentColorHelper';

import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import { getTranslatedString } from 'helpers/i18n';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import TableFilters from 'components/ui/TableFilters';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';
import { featureEnabled } from 'helpers/ToggleBot';
import { default as AntDrawer } from 'components/ui/Drawer';
import { ViewPurchaseOrderDrawer } from './components/ViewPurchaseOrderDrawer';
import { AddPurchaseOrderDrawer } from './components/AddPurchaseOrderDrawer';
import { purchaseOrderColumns } from './components/helpers/purchaseOrderColumns';

const purchaseOrderStatuses = ['pending_approval', 'approved', 'denied', 'needs_review'];

const LandlordPurchaseOrders = withMobileDialog()(
  connect(
    (store) => ({
      properties: store.landlordProperties.properties,
      purchaseOrders: store.landlordPurchaseOrders.purchaseOrders,
      fetchingPurchaseOrders: store.landlordPurchaseOrders.fetchingPurchaseOrders,
      purchaseOrderStats: store.landlordPurchaseOrders.purchaseOrderStats,
      purchaseOrder: store.landlordPurchaseOrders.purchaseOrder,
      vendors: store.landlordPurchaseOrders.vendors,
    }),
    {
      getProperties,
      getUnits,
      getAllPurchaseOrders,
      getPurchaseOrderStats,
      getPurchaseOrder,
      getVendors,
      getGlAccounts,
      getExpenseTypes,
    }
  )(
    class LandlordPurchaseOrder extends Component {
      constructor(props) {
        super(props);
        this.state = {
          showFilters: true,
          filtersActive: false,
          filters: {
            search: '',
            properties: Array(this.props.properties.length).fill(false),
            purchaseOrderStatuses: Array(purchaseOrderStatuses.length).fill(false),
          },
          currentTab: 'needs_review',
          sortKey: '',
          sortOrder: '',
          offset: 0,
          viewPurchaseOrder: false,
          toggleNewPurchaseOrder: false,
        };
      }

      setRef = (ref) => (this.table = ref);

      componentDidMount = () => {
        this.props.getProperties({ for_multiselect: true, show_cities: true });
        if (!featureEnabled('purchase_order')) {
          browserHistory.push('/companies/dashboard');
        }

        const { purchaseOrderId } = this.props.routeParams;
        this.props.getPurchaseOrderStats();
        this.fetchPurchaseOrders();
        this.props.getVendors().then(() => {
          if (purchaseOrderId) {
            this.toggleViewPurchaseOrderDrawer(purchaseOrderId);
          }
        });
      };

      onCreateSuccess = () => {
        this.props.getPurchaseOrderStats();
        this.setState(
          {
            offset: 0,
          },
          () => this.fetchPurchaseOrders()
        );
      };

      handleClearSearch = (setFieldValue) => {
        this.setState(
          {
            filtersActive: false,
            filters: {
              search: '',
              properties: Array(this.props.properties.length).fill(false),
              purchaseOrderStatuses: Array(purchaseOrderStatuses.length).fill(false),
            },
            offset: 0,
          },
          () => this.fetchPurchaseOrders()
        );
        if (this.table) this.table.scrollToTop(0);
        setFieldValue('search', '');
        setFieldValue('properties', Array(this.props.properties.length).fill(false));
        setFieldValue('purchaseOrderStatuses', Array(purchaseOrderStatuses.length).fill(false));
      };

      handleFilters = (values) => {
        const isFiltersUntouched =
          values.search === '' &&
          !values.properties.includes(true) &&
          !values.purchaseOrderStatuses.includes(true);
        const newState = {
          filtersActive: !isFiltersUntouched,
          filters: {
            search: values.search,
            properties: values.properties,
            purchaseOrderStatuses: values.purchaseOrderStatuses,
          },
          drawerVisible: false,
          offset: 0,
        };
        if (this.table) this.table.scrollToTop(0);
        this.setState(newState, () => this.fetchPurchaseOrders());
      };

      fetchPurchaseOrders = (options = {}) => {
        let { filters, filtersActive, currentTab, offset, sortKey, sortOrder } = this.state;
        let fetchPromise = null;

        let filterOptions = {
          sort_key: sortKey,
          sort_order: sortOrder,
        };

        if (options.updateList) {
          offset = 0;
        }

        const filterArray = (array, booleanArrayMask) => {
          return array.filter((_, i) => booleanArrayMask[i]);
        };

        if (filtersActive) {
          const propertiesToFilter = filterArray(this.props.properties, filters.properties).map(
            (data) => data.value
          );
          const purchaseOrderStatusesToFilter = filterArray(
            purchaseOrderStatuses,
            filters.purchaseOrderStatuses
          );

          filterOptions = {
            query: filters.search,
            property_ids: propertiesToFilter,
            purchase_order_statuses: purchaseOrderStatusesToFilter,
            sort_key: sortKey,
            sort_order: sortOrder,
          };

          fetchPromise = this.props.getAllPurchaseOrders('', offset, filterOptions);
        } else {
          fetchPromise = this.props.getAllPurchaseOrders(currentTab, offset, filterOptions);
        }

        fetchPromise.then(() => {
          this.setState({
            offset: this.props.purchaseOrders.length,
          });
        });
      };

      handleSort = (key, order) => {
        this.setState(
          {
            sortKey: key,
            sortOrder: order,
            offset: 0,
          },
          () => {
            this.fetchPurchaseOrders();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      toggleViewPurchaseOrderDrawer = async (purchaseOrderId) => {
        if (!this.state.viewPurchaseOrder && purchaseOrderId) {
          this.props.getGlAccounts();
          this.props.getExpenseTypes();

          await this.props.getPurchaseOrder(purchaseOrderId);
          this.toggleViewPurchaseOrder();
          return;
        }
        this.setState({
          viewPurchaseOrder: false,
        });
      };

      columns = purchaseOrderColumns();

      handleTabChange = (tabName) => {
        this.setState(
          {
            currentTab: tabName,
            offset: 0,
          },
          () => {
            this.fetchPurchaseOrders();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      toggleViewPurchaseOrder = () => {
        this.setState({
          viewPurchaseOrder: !this.state.viewPurchaseOrder,
        });
      };

      accentColor = AccentColor();

      toggleNewPurchaseOrder = () => {
        this.setState({
          toggleNewPurchaseOrder: !this.state.toggleNewPurchaseOrder,
        });
      };

      render() {
        const { filters } = this.state;
        const { purchaseOrders, purchaseOrderStats } = this.props;

        const filterOptions = [
          {
            useSearch: true,
            options: this.props.properties.map((data) => data.label),
            name: 'properties',
            title: getTranslatedString('landlordPortal.purchaseOrders.selectPropertiesToFilterBy'),
          },
          {
            useSearch: false,
            options: purchaseOrderStatuses.map((statusCode) => {
              return getTranslatedString(
                `landlordPortal.landlordPurchaseOrder.status.${camelCase(statusCode)}`
              );
            }),
            name: 'purchaseOrderStatuses',
            title: getTranslatedString(
              'landlordPortal.landlordPurchaseOrder.filterPurchaseOrderByStatus'
            ),
          },
        ];

        const tabs = [
          {
            title: getTranslatedString('landlordPortal.purchaseOrders.needsAction'),
            label: getTranslatedString('landlordPortal.purchaseOrders.needsAction'),
            value: 'needs_review',
            count: purchaseOrderStats['needs_action'] || 0,
            onClick: () => this.handleTabChange('needs_review', { subset: 'needs_review' }),
          },
          {
            title: getTranslatedString('landlordPortal.purchaseOrders.pending'),
            label: getTranslatedString('landlordPortal.purchaseOrders.pending'),
            value: 'pending_approval',
            count: purchaseOrderStats['pending_approval'] || 0,
            onClick: () =>
              this.handleTabChange('pending_approval', {
                subset: 'pending_approval',
              }),
          },
          {
            title: getTranslatedString('landlordPortal.purchaseOrders.approved'),
            label: getTranslatedString('landlordPortal.purchaseOrders.approved'),
            value: 'approved',
            count: purchaseOrderStats['approved'] || 0,
            onClick: () => this.handleTabChange('approved', { subset: 'approved' }),
          },
          {
            title: getTranslatedString('landlordPortal.purchaseOrders.denied'),
            label: getTranslatedString('landlordPortal.purchaseOrders.denied'),
            value: 'denied',
            count: purchaseOrderStats['denied'] || 0,
            onClick: () => this.handleTabChange('denied', { subset: 'denied' }),
          },
          {
            title: getTranslatedString('landlordPortal.purchaseOrders.all'),
            label: getTranslatedString('landlordPortal.purchaseOrders.all'),
            value: 'all',
            count: purchaseOrderStats['all'] || 0,
            onClick: () => this.handleTabChange('all', { subset: 'all' }),
          },
        ];

        return (
          <StyledMain>
            <StyledHeaderContainer>
              <StyledHeader>
                <HeaderWithPeriod
                  headerText={
                    <span>
                      {getTranslatedString('landlordPortal.purchaseOrders.purchaseOrders')}
                    </span>
                  }
                  newStyle
                />
                <StyledAddButton
                  accentColor={this.accentColor}
                  onClick={() => this.toggleNewPurchaseOrder()}
                >
                  {getTranslatedString('landlordPortal.purchaseOrders.addNew')}
                </StyledAddButton>
                <AntDrawer
                  maskClosable={false}
                  keyboard
                  visible={this.state.toggleNewPurchaseOrder}
                  onClose={this.state.toggleNewPurchaseOrder}
                  closable={false}
                  width={600}
                >
                  {this.state.toggleNewPurchaseOrder && (
                    <AddPurchaseOrderDrawer
                      toggleNewPurchaseOrder={this.toggleNewPurchaseOrder}
                      onSuccess={this.onCreateSuccess}
                    />
                  )}
                </AntDrawer>
              </StyledHeader>
              <TableFilters
                filters={filters}
                handleSubmitFilters={this.handleFilters}
                handleClearFilters={this.handleClearSearch}
                filterOptions={filterOptions}
                accentColor={this.accentColor}
              />
            </StyledHeaderContainer>
            <AntDrawer
              maskClosable={false}
              keyboard
              visible={this.state.viewPurchaseOrder}
              onClose={this.state.viewPurchaseOrder}
              closable={false}
              width={600}
            >
              {this.state.viewPurchaseOrder && (
                <ViewPurchaseOrderDrawer
                  toggleViewPurchaseOrder={this.toggleViewPurchaseOrder}
                  purchaseOrder={this.props.purchaseOrder}
                  fetchPurchaseOrders={this.fetchPurchaseOrders}
                />
              )}
            </AntDrawer>

            <StyledTableContainer>
              {this._renderTableView({ purchaseOrders, tabs })}
              {this._renderMobileView({
                purchaseOrders,
                tabs,
                currentTab: this.state.currentTab,
                tabChange: this.handleTabChange,
              })}
            </StyledTableContainer>
          </StyledMain>
        );
      }

      _renderMobileView = ({ purchaseOrders, tabs, currentTab, tabChange }) => (
        <MediaQuery query="(max-device-width: 750px)">
          <MobileTable
            groupRowsBy="property_name"
            data={purchaseOrders}
            tabs={tabs}
            tabIndex={currentTab}
            tabChange={tabChange}
            filtersActive={this.state.filtersActive}
            columns={this.columns}
            title="title"
            tag="status"
            stickyHeaderTop={this.state.filters.search ? '137px' : '107px'}
            fieldsAboveFold={[
              {
                title: getTranslatedString('landlordPortal.purchaseOrders.dueDate'),
                key: 'required_date',
              },
              {
                title: getTranslatedString('landlordPortal.purchaseOrders.vendor'),
                key: 'external_vendor_name',
                renderer: (data) => {
                  let vendor_name = data;

                  if (data != null && data.length > 15) {
                    vendor_name = vendor_name.substring(0, 14) + '...';
                  }
                  return vendor_name;
                },
              },
            ]}
            fieldsBelowFold={[
              {
                title: getTranslatedString('landlordPortal.purchaseOrders.poNumber'),
                key: 'po_number',
              },
              {
                title: getTranslatedString('landlordPortal.purchaseOrders.ticketNumber'),
                key: 'ticket_numbers',
              },
              {
                title: getTranslatedString('landlordPortal.purchaseOrders.itemQty'),
                key: 'total_quantity',
              },
              {
                title: getTranslatedString('landlordPortal.purchaseOrders.dateSubmitted'),
                key: 'created_at',
              },
            ]}
            onRowClick={(data) => {
              this.toggleViewPurchaseOrderDrawer(data.id);
            }}
          />
        </MediaQuery>
      );

      _renderTableView = ({ purchaseOrders, tabs }) => (
        <MediaQuery query="(min-device-width: 750px)">
          <TabbedTable
            setRef={this.setRef}
            groupRowsBy="property_name"
            tabs={tabs}
            columns={this.columns}
            data={purchaseOrders}
            loadMoreData={this.fetchPurchaseOrders}
            isLoading={this.props.fetchingPurchaseOrders}
            filtersActive={this.state.filtersActive}
            onRowClick={(data) => {
              this.toggleViewPurchaseOrderDrawer(data.original_id);
            }}
            onColumnClick={(data) => {
              this.handleSort(data.key, data.order);
            }}
          />
        </MediaQuery>
      );
    }
  )
);

export default withRouter(LandlordPurchaseOrders);
